import React, { useState, useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import About from "./pages/About";
import PCBGuide from "./pages/PCBGuide";
import { translations } from "./locales";
import "./App.css";

function App() {
  const [lang, setLang] = useState("ko");
  const t = translations[lang];

  // 모든 섹션 이동을 위한 Ref 생성
  const bizRef = useRef(null);
  const historyRef = useRef(null);
  const clientRef = useRef(null);
  const mapRef = useRef(null);
  const pcbRef = useRef(null);
  const priceRef = useRef(null);
  const deliveryRef = useRef(null);

  const sectionRefs = {
    bizRef,
    historyRef,
    clientRef,
    mapRef,
    pcbRef,
    priceRef,
    deliveryRef,
  };

  // 스크롤 이동 함수
  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      const offset = 150;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = ref.current.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <Router>
      <div className="App">
        {/* Navbar에 인자 전달 */}
        <Navbar
          lang={lang}
          setLang={setLang}
          t={t}
          scrollToSection={scrollToSection}
          refs={sectionRefs}
        />

        <div className="content-area">
          <Routes>
            <Route path="/" element={<About t={t} ref={sectionRefs} />} />
            <Route path="/about" element={<About t={t} ref={sectionRefs} />} />
            <Route
              path="/PCBGuide"
              element={<PCBGuide t={t} ref={sectionRefs} />}
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
